import { createStore } from 'stimulus-store';

export const allDeviceTypesStore = createStore({
    name: 'allDeviceTypesStore',
    type: Array,
    initialValue: []
});